
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ProductAboutSection',
  props: {
    content: {
      type: String,
      default: '',
    },
    link: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
});
